import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import FooterSection from './components/FooterSection';
import CursorTrail from './components/CursorTrail';
import Home from './pages/Home';
import ComoFunciona from './pages/ComoFunciona';
import Precios from './pages/Precios';
import KompaClub from './pages/KompaClub';
import FAQ from './pages/FAQ';
import InvestorLogin from './pages/InvestorLogin';
import Investors from './pages/Investors';

function AppContent() {
  const location = useLocation();
  const isInvestorArea = location.pathname === '/investor-login' || location.pathname === '/investors';

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div className="App overflow-x-hidden">
      {!isInvestorArea && <CursorTrail />}
      {!isInvestorArea && <Header scrollToSection={scrollToSection} />}
      <Routes>
        <Route path="/" element={<Home scrollToSection={scrollToSection} />} />
        <Route path="/como-funciona" element={<ComoFunciona scrollToSection={scrollToSection} />} />
        <Route path="/precios" element={<Precios />} />
        <Route path="/kompa-club" element={<KompaClub />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/investor-login" element={<InvestorLogin />} />
        <Route path="/investors" element={<Investors />} />
      </Routes>
      {!isInvestorArea && <FooterSection scrollToSection={scrollToSection} />}
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
